import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";

const ChatLayout = ({ userId, role }) => {
  return (
     <div class="chat-area">
      <ChatSidebar />
      <ChatWindow userId={userId} role={role} />
    </div>
  );
};

export default ChatLayout;
